module.exports = __webpack_public_path__ + "static/img/egg.267908f9.png";